"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareDescription = void 0;
// regex
// newlines
const newlines = /\r\n|\r|\n/g;
// braille pattern blank
const brailleWhitespace = /⠀/g;
// hashtags
const hashtag = /#/g;
// spaces ...
const spaces = /\s{2,}/g;
const prepareDescription = caption => caption.replaceAll(newlines, ' ').replaceAll(brailleWhitespace, ' ').replaceAll(hashtag, ' #').replaceAll(spaces, ' ');
exports.prepareDescription = prepareDescription;
